import { render, staticRenderFns } from "./StatisticsTimeView.vue?vue&type=template&id=022d5978&scoped=true"
import script from "./StatisticsTimeView.vue?vue&type=script&lang=js"
export * from "./StatisticsTimeView.vue?vue&type=script&lang=js"
import style0 from "./StatisticsTimeView.vue?vue&type=style&index=0&id=022d5978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d5978",
  null
  
)

export default component.exports